import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export var init = createAction(actionTypePrefix + "/INIT", function () { return ({}); });
export var initDoneAlready = createAction(actionTypePrefix + "/INIT_DONE_ALREADY", function () { return ({}); });
export var initDone = createAction(actionTypePrefix + "/INIT_DONE", function (result) { return ({
    result: result,
}); });
export var switchStream = createAction(actionTypePrefix + "/SWITCH_STREAM", function (payload) { return payload; });
export var initStreamDone = createAction(actionTypePrefix + "/INIT_STREAM_DONE", function (streamType, result) { return ({
    streamType: streamType,
    result: result,
}); });
export var streamLoadMore = createAction(actionTypePrefix + "/STREAM_LOAD_MORE", function () { return ({}); });
export var streamLoadDone = createAction(actionTypePrefix + "/STREAM_LOAD_DONE", function (streamType, result) { return ({
    streamType: streamType,
    result: result,
}); });
export var storeSearchData = createAction(actionTypePrefix + ".STORE_SEARCH_DATA", function (searchType, searchQuery) { return ({ searchType: searchType, searchQuery: searchQuery }); });
//# sourceMappingURL=actionCreators.js.map